import { GridCellProps } from "@progress/kendo-react-grid";
import StatusChip from "../../commons/components/StatusChip";

export default function StatusCell(props: GridCellProps) {
    return <td colSpan={1} className="k-table-td" role="gridcell" aria-colindex={9} aria-selected="false" data-grid-col-index="8"><StatusChip statuts={props.dataItem.listes} /></td>;
}